import { posthog } from "./posthog";
import { readFirstTouch, readLeadId } from "./first-touch";

export interface ReportCheckoutContext {
  posthogDistinctId?: string;
  posthogSessionId?: string;
  utmSource?: string;
  utmMedium?: string;
  utmCampaign?: string;
  utmContent?: string;
  utmTerm?: string;
  referrerHost?: string;
  leadId?: string;
}

/**
 * What the browser knows at the moment Checkout is opened.
 *
 * Distinct id is read even when capture is opted out: it is sent to our API
 * and stored on the Stripe Session, which is how a purchase joins the visit
 * when cookies are not allowed yet. It is not a PostHog cookie write.
 */
export function readCheckoutContext(slug: string): ReportCheckoutContext {
  const touch = readFirstTouch();
  const context: ReportCheckoutContext = { ...touch };
  const leadId = readLeadId(slug);
  if (leadId) {
    context.leadId = leadId;
  }

  try {
    const loaded = (posthog as { __loaded?: boolean }).__loaded === true;
    if (loaded) {
      const distinctId = posthog.get_distinct_id();
      if (distinctId) {
        context.posthogDistinctId = distinctId;
      }
      const sessionId = posthog.get_session_id();
      if (sessionId) {
        context.posthogSessionId = sessionId;
      }
    }
  } catch {
    // Checkout must proceed if the SDK throws.
  }

  return context;
}
